import * as Yup from 'yup';
import { StepTypeForm } from './step-type-types';
import { RoleRequestType } from '../../../models';

export const stepTypeSchema = () =>
  Yup.object<StepTypeForm>().shape({
    type: Yup.mixed<RoleRequestType>().nullable().required('Povinné pole'),
  });
